import { get } from "lodash-es";
import { MESApiService, spParameter } from "../../../../services";
import { Action, CacheInvalidation, QueryCacheResponse } from "../config";

export const getQueryCacheInvalidations = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[SYSTEM].[GetQueryCacheInvalidations]",
		[],
		signal,
	);

	if (resp.ok) {
		let cacheInvalidations = get(
			resp,
			"data.tables[0].rows",
			[],
		) as CacheInvalidation[];
		let actions = get(resp, "data.tables[1].rows", []) as Action[];

		return {
			cacheInvalidations,
			actions,
		} as QueryCacheResponse;
	} else {
		throw new Error(resp.message || "Error fetching query cache invalidations");
	}
};

export const upsertQueryCacheInvalidations = async ({
	actionId,
	targets,
}: {
	actionId: number;
	targets: Action[];
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[SYSTEM].[UpsertQueryCacheInvalidations]",
		[
			{
				name: "SourceId",
				value: actionId,
			},
			{
				name: "TargetsCSV",
				value: targets.map((t) => t.ActionId).join(","),
			},
		],
	);

	if (!resp.ok) {
		throw new Error(
			resp.message || "Error when upsert query cache invalidations",
		);
	}
};
